import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ClaimService } from '../../shared/claimservice';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'app-claim-component',
    templateUrl: './claim.component.html',
    styles: [`
      .claim-modal-backdrop {
        position: fixed;
        inset: 0;
        z-index: 1050;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        background: rgba(0, 0, 0, .75);
      }
      .claim-modal {
        width: min(100%, 900px);
        background: #fff;
        border-radius: .25rem;
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .25);
      }
      .claim-modal-header,
      .claim-modal-body,
      .claim-modal-footer {
        padding: 1rem;
      }
      .claim-modal-header {
        border-bottom: 1px solid #dee2e6;
        background: #f7f7f7;
      }
      .claim-modal-footer {
        border-top: 1px solid #dee2e6;
        background: #f7f7f7;
        text-align: center;
      }
    `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimComponent {
  claimControlNumber: Number = 0;
  serviceResult: any;
  selectedScreen: any = {};
  claimStatus:String;
  claimStatusReason:String;
  claimRefNum:any;
  subCompanyCode:String;
  constructor(private claimService: ClaimService, private route: ActivatedRoute, private changeDetector: ChangeDetectorRef) {

  }

  modalText = '';
  modalHeader = '';
  modalVisible = false;

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if(this.route.snapshot.data['data'].error !== undefined){
          this.showModalPopupMessage(this.route.snapshot.data['data'].error, 'Error');
      }
      else{
        this.claimControlNumber = +this.route.snapshot.params['id'];
        this.serviceResult = this.route.snapshot.data['data'].result;
        this.claimControlNumber = this.serviceResult.header.controlNumber;
        this.claimStatus = this.serviceResult.header.status; 
        this.claimStatusReason = this.serviceResult.header.statusReason; 
        this.subCompanyCode = this.serviceResult.header.companyCode;    
        let errMsg = this.route.snapshot.data['data'].errorMessage;
        if(errMsg !== null && errMsg !== ''){
          this.showModalPopupMessage(errMsg, 'Alert');
        }    
      }
    });
  }

  closeModal(){
    this.modalVisible = false;
    this.changeDetector.detectChanges();
  }

  displayScreen(id) {
    //console.log('displayscreen: ' + JSON.stringify(this.serviceResult.screens.find(s => s.id == id)));
    if (this.serviceResult.screens.find(s => s.id == id) !== undefined) {
      let currentScreen = this.serviceResult.screens.find(s => s.id == id);
      if(currentScreen.description === 'VERIFY TRANSMIT DETAILS'){
        if(currentScreen.dataEntities.length === 0){
          this.showModalPopupMessage('Please check your Policy Number or Date of Loss before transmitting the claim.', 'Transmit');
        }
        else{
          //let policyIdField = currentScreen.dataEntities[0].fields.find(f => f.fieldDescription === 'Policy Id:');
          if(!currentScreen.canBeTransmitted){
            this.showModalPopupMessage('Please check your Policy Number or Date of Loss before transmitting the claim.', 'Transmit');
          }
        }
      }
      this.selectedScreen = this.serviceResult.screens.find(s => s.id == id);
    }
    else {
      this.selectedScreen = {
        id: 0,
        description: id
      };  
    }
  }

  onCantBeTransmitted($event){
    this.showModalPopup($event, 'Transmit');
  }

  onPolicyNumberUpdated($event){
    this.showModalPopup($event, 'Policy Updated');
  }

  onZipCodeUpdated($event){
    this.showModalPopup($event, 'ZipCode Updated');
  }

  onSendReportOfloss($event){
    this.showModalPopup($event, 'SendReportOfLoss');
  }

  sentAcknowledgement($event) {
    this.showModalPopup($event, 'Acknowledgement');
  }

  refreshScreen($event) {
    this.claimService.getClaim(this.claimControlNumber).subscribe(response => {
      this.serviceResult = (<GetClaimResponse>response).result;
      this.claimStatus = this.serviceResult.header.status;
      this.claimStatusReason = this.serviceResult.header.statusReason;
      if ((<GetClaimResponse>response).result.screens.find(s => s.id == this.selectedScreen.id) !== undefined) {
        this.selectedScreen = (<GetClaimResponse>response).result.screens.find(s => s.id == this.selectedScreen.id);
      }
      else {
        this.selectedScreen = {
          id: 0,
          description: this.selectedScreen.description
        };  
      }
      this.showModalPopup($event, 'Transmit');
     });
    }

    onSaveTransmitDetails($event){
      this.claimService.getClaim(this.claimControlNumber).subscribe(response => {
        this.serviceResult = (<GetClaimResponse>response).result;
        this.claimStatus = this.serviceResult.header.status;
        this.claimStatusReason = this.serviceResult.header.statusReason;
        if ((<GetClaimResponse>response).result.screens.find(s => s.id == this.selectedScreen.id) !== undefined) {
          this.selectedScreen = (<GetClaimResponse>response).result.screens.find(s => s.id == this.selectedScreen.id);
        }
        else {
          this.selectedScreen = {
            id: 0,
            description: this.selectedScreen.description
          };  
        }
        this.showModalPopup($event, 'Save');
       });
    }

    showModalPopupMessage(message, header){
      setTimeout(() => {
        this.modalHeader = header;
        this.modalText = message;
        this.modalVisible = true;
        this.changeDetector.detectChanges();
      });
    }

    showModalPopup($event, header){
      if($event !== undefined){
        setTimeout(() => {
          if($event.event.message !== ''){
            this.modalHeader = header;
            this.modalText = $event.event.message;
          }
          else if($event.event.error !== ''){
            this.modalHeader = 'Error';
            this.modalText = $event.event.error;
          }
          this.modalVisible = true;
          this.changeDetector.detectChanges();
        });
      }
    }
  }

  class GetClaimResponse{
    result:any;
  }
